import React, {Component} from 'react';
import axios from 'axios';
import config from "../../../config";
import i18n from "../../../i18n";
import {route} from "../../../routes";
import {withError, withJobInformationApi, withStyleguide} from "cw-styleguide-react";
import SubjectsLandingView from "../views/SubjectsLandingView";

class SubjectsLandingController extends Component {
  constructor(props) {
    super(props);
    this.state = {
      introduction: '',
      subjects: []
    };
  }

  componentDidMount() {
    this.props.jobInformationApiGetSubjectTitles(i18n.language, (response) => {
      this.setState({
        subjects: response.data
      });


    }, (error) => {

    });



    this.props.styleguide.setLanguageUrl(route('subjects', null, i18n.language === 'en' ? 'cy' : 'en'));
  }

  // componentDidUpdate(prevProps, prevState, snapshot) {
  //   if (typeof window.initialiseCard === 'function') {
  //     window.initialiseCard();
  //   }
  // }

  render() {
    return (
      <SubjectsLandingView {...this.state} {...this.props}/>
    );
  }
}

export default withJobInformationApi(withStyleguide(withError(SubjectsLandingController)));
